import React, { useState } from "react";
import styled from "styled-components/macro";
import SwaggerUI from "swagger-ui-react";
import "swagger-ui-react/swagger-ui.css";
import { Helmet } from "react-helmet-async";

import {
  Breadcrumbs as MuiBreadcrumbs,
  Divider as MuiDivider,
  Grid as MuiGrid,
  Typography,
  Select,
  MenuItem,
  InputLabel,
  FormControl,
} from "@material-ui/core";

import { spacing } from "@material-ui/system";

const Breadcrumbs = styled(MuiBreadcrumbs)(spacing);

const Divider = styled(MuiDivider)(spacing);

const Grid = styled(MuiGrid)(spacing);

const swaggerVersions = {
  v1: process.env.REACT_APP_DATA_API_DOCUMENT_URL_V1,
  v2: process.env.REACT_APP_DATA_API_DOCUMENT_URL_V2,
};

const Wrapper = styled("div")`
  padding: 0 10px;
  background-color: white;
`;

function ApiDocumentation() {
  const [selectedVersion, setSelectedVersion] = useState("v1");

  const handleChange = (event) => {
    setSelectedVersion(event.target.value);
  };
  return (
    <React.Fragment>
      <Helmet title="Api Documentation" />

      <Typography variant="h3" gutterBottom display="inline">
        Api Documentation
      </Typography>

      <Breadcrumbs aria-label="Breadcrumb" mt={2}>
        <Typography>Pages</Typography>
        <Typography>Api Documentation</Typography>
      </Breadcrumbs>

      <Divider my={6} />

      <Wrapper>
        <Grid container alignItems="center" justify="flex-start">
          <Grid item md={12}>
            <FormControl variant="outlined" style={{ minWidth: 180, marginBottom: 16 }}>
              <InputLabel id="swagger-version-select-label">Version</InputLabel>
              <Select
                labelId="swagger-version-select-label"
                id="swagger-version-select"
                value={selectedVersion}
                onChange={handleChange}
                label="Version"
              >
                {Object.entries(swaggerVersions).map(([key, url]) => (
                  url ? (
                    <MenuItem key={key} value={key}>
                      {key.toUpperCase()}
                    </MenuItem>
                  ) : null
                ))}
              </Select>
            </FormControl>
            <SwaggerUI url={swaggerVersions[selectedVersion]} />
          </Grid>
        </Grid>
      </Wrapper>
    </React.Fragment>
  );
}

export default ApiDocumentation;
